import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Label,
} from "@fluentui/react-components";
import { DeleteRegular } from "@fluentui/react-icons";
import i18n from "i18next";
import { useState } from "react";

interface IDialogDeleteUserProps {
  openDialog: boolean;
  onDelete(): void;
  onDeleteAndSendMail(): void;
  onCancel(): void;
}
function DialogDeleteUser(props: IDialogDeleteUserProps) {
  const [sendMail, setSendMail] = useState<boolean>(false);
  return (
    <Dialog open={props.openDialog}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.t<string>("deleteUser")}</DialogTitle>
          <DialogContent style={{ display: "flex", flexDirection: "column" }}>
            <Label>{i18n.t<string>("deleteUserText")}</Label>
            <Checkbox
              checked={sendMail}
              onChange={() => {
                setSendMail(!sendMail);
              }}
              label={"Bestätigungsmail senden"}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                sendMail ? props.onDeleteAndSendMail() : props.onDelete();
              }}
              appearance="primary"
              icon={<DeleteRegular />}
            >
              {i18n.t<string>("deleteUser")}
            </Button>
            <Button
              onClick={() => {
                props.onCancel();
              }}
            >
              {i18n.t<string>("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogDeleteUser;
